import { createWidgetConfigLoader, queryClient, WidgetApiError } from "@blockdaemon/widget-host";

import type { WidgetConfig } from "../lib/config-schema";

// The earn loader lives here (not in widget-host) because earn's embedding
// contract supports token-based auth that is specific to this product.
// The showcase reaches it via the earn-widget package exports.
const loader = createWidgetConfigLoader<WidgetConfig>("earn", "/api/config");

/** TanStack Query prefix for Earn widget customer config (`GET /api/config`). */
export const EARN_CONFIG_QUERY_ROOT = loader.QUERY_ROOT;

export { WidgetApiError };

export const cacheWidgetConfig = loader.cacheConfig;
export const fetchConfig = loader.fetchConfig;
export const useConfig = loader.useConfigQuery;

export function getCachedWidgetConfig(client: typeof queryClient = queryClient) {
  const latestConfigQuery = client
    .getQueryCache()
    .findAll({ queryKey: EARN_CONFIG_QUERY_ROOT })
    .reduce<{ data: WidgetConfig; updatedAt: number } | undefined>((latest, query) => {
      const data = query.state.data as WidgetConfig | undefined;
      if (data === undefined) {
        return latest;
      }

      const current = {
        data,
        updatedAt: query.state.dataUpdatedAt,
      };

      if (!latest || current.updatedAt >= latest.updatedAt) {
        return current;
      }

      return latest;
    }, undefined);

  return latestConfigQuery?.data;
}
